"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.999 3.698a.7.7 0 0 1 .7-.7h12.603a.7.7 0 0 1 .7.7v4.784a.7.7 0 1 1-1.4 0v-.933H4.399v8.053H9a.7.7 0 1 1 0 1.4H3.699a.7.7 0 0 1-.7-.7zm1.4 2.451h11.203V4.4H4.399z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.699 2.998a.7.7 0 0 0-.7.7v12.604a.7.7 0 0 0 .7.7H9a.7.7 0 1 0 0-1.4H4.399V7.548h11.203v.933a.7.7 0 1 0 1.4 0V3.698a.7.7 0 0 0-.7-.7zm.7 3.151V4.4h11.203v1.75z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.578 10.173a.7.7 0 0 1 .07.988l-.643.739h3.76l-.642-.74a.7.7 0 1 1 1.057-.918l1.65 1.898a.7.7 0 0 1 0 .919l-1.65 1.898a.7.7 0 0 1-1.057-.919l.642-.738h-3.76l.642.738a.7.7 0 0 1-1.056.919l-1.65-1.898a.7.7 0 0 1 0-.919l1.65-1.898a.7.7 0 0 1 .987-.069",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TimescaleIcon20.js.map